module.exports = __webpack_public_path__ + "img/no-circle.d4abba94.svg";